<template>
  <v-alert
    :value="true"
    :color="resolvedColor"
    class="diagnostics-health-banner mb-2"
    outline
  >
    <div class="d-flex align-center">
      <v-icon class="mr-2">{{ resolvedIcon }}</v-icon>
      <strong>{{ title }}</strong>
    </div>
    <v-layout row wrap align-center>
      <v-flex xs12 sm8>
        <div v-if="subtitle" class="caption mt-1">{{ subtitle }}</div>
        <div v-if="lastUpdatedLabel" class="caption">{{ lastUpdatedLabel }}</div>
      </v-flex>
      <v-flex xs12 sm4 class="text-sm-right mt-2 mt-sm-0">
        <slot name="actions" />
      </v-flex>
    </v-layout>
  </v-alert>
</template>

<script>
import { statusColor, statusIcon } from './status-mapping'

export default {
  name: 'diagnostics-system-health-banner',
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: ''
    },
    status: {
      type: String,
      default: 'unknown'
    },
    lastUpdatedLabel: {
      type: String,
      default: ''
    }
  },
  computed: {
    resolvedColor () {
      return statusColor(this.status)
    },
    resolvedIcon () {
      return statusIcon(this.status)
    }
  }
}
</script>

<style scoped>
.diagnostics-health-banner {
  border-radius: 6px;
}
</style>
